<template>
  <div class="">
    <loading v-if="loading"></loading>
    <Head>
      <template #header-left>
        <BaseButton 
          variant="secondary" 
          @click="$router.push(`/orders-delivery/delivery-order-detail/${id}`)"
        >
          Hủy
        </BaseButton>
      </template>

      <template #title>
        <p>Chỉnh sửa đơn giao hàng</p>
      </template>

      <template #header-right>
        <div>
          <el-button 
            type="primary"
            @click="updateDLO"
          >
            Hoàn tất
          </el-button>
        </div>
      </template>
    </Head>

    <div class="boxContent boxContentExt" style="margin-top:110px">
      <div class="__card first-box">
        <LayoutCardTitle>Thông tin đơn vận</LayoutCardTitle>
        <el-form label-width="160px" style="width: 100%;" :inline="true">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Mã đơn giao:" class="m-0">
                <strong class="mr-3"> {{checkEmpty(dataItem.orderNo)}}</strong>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="TG xuất kho:" class="m-0">
                <strong class="mr-3"> {{checkoutAt}}</strong>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Mã đơn hàng:" class="mb-0">
                <strong> {{ checkEmpty(dataItem.furtherInstructions[0].params.soOrderNo) }}</strong>
                <a class="text-primary cursor" @click="linkTo()" style="padding-left: 8px;">
                  <i class="fa-solid fa-up-right-from-square mr-1"></i> Chi tiết đơn hàng
                </a>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Ngày mua:" label-width="160px" class="mb-0">
                <span>{{ checkEmpty(this.timeFormatStatus(dataItem.createdAt)) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="Người tạo:" class="mb-0">
                <span>{{ checkEmpty(dataItem.partyA.displayName) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="Địa chỉ lấy hàng:" class="mb-0">
                <span>{{checkEmpty(dataItem.furtherInstructions[0].params.pickUpAddress)}}</span>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col :span="20">
              <el-form-item label="Ghi chú:" class="mb-0">
                <el-input v-model="infoNote" type="textarea" placeholder="Nhập ghi chú" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <p class="__card_title">Thông tin người nhận</p>
        <el-form label-width="160px" style="width: 100%;" :inline="true">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Họ và tên:" class="mb-0">
                <el-input v-model="dataItem.partyB.displayName"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Điện thoại:" class="mb-0">
                <el-input v-model="dataItem.partyB.phoneNo" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Tỉnh/Thành phố:">
                <multiselect class="test"
                  v-model="dataCustomer.city"
                  track-by="id"
                  label="text"
                  deselectLabel=""
                  selectLabel=""
                  selectedLabel=""
                  placeholder="Chọn Tỉnh/Thành phố"
                  :options="listCity"
                  :allow-empty="false"
                  @select="getListDistrict($event)">
                  <template slot="noOptions"> Chưa có dữ liệu </template>
                  <template slot="noResult">Không tìm thấy dữ liệu</template>
                </multiselect>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Quận/Huyện:" label-width="160px">
                <multiselect
                  v-model="dataCustomer.district"
                  track-by="id"
                  label="text"
                  deselectLabel=""
                  selectLabel=""
                  selectedLabel=""
                  placeholder="Chọn Quận/Huyện"
                  :options="listDistrict"
                  :allow-empty="false"
                  @select="getListWard($event)">
                  <template slot="noOptions"> Chưa có dữ liệu </template>
                  <template slot="noResult">Không tìm thấy dữ liệu</template>
                </multiselect>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Phường/Xã:">
                <multiselect
                  v-model="ward"
                  track-by="id"
                  label="text"
                  deselectLabel=""
                  selectLabel=""
                  selectedLabel=""
                  placeholder="Chọn Phường/Xã"
                  :options="listWard">
                  <template slot="noOptions"> Chưa có dữ liệu </template>
                  <template slot="noResult">Không tìm thấy dữ liệu</template>
                </multiselect>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
                <el-form-item label="Địa chỉ cụ thể"  class="mb-0">
                <el-input v-model="dataItem.furtherInstructions[0].params.shippingAddress" type="textarea" placeholder="Nhập ghi chú" />
                </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <p class="__card_title">Hình thức giao hàng</p>
        <el-form label-width="160px" style="width: 100%;" :inline="true">
            <el-row class="first-child">
                <el-col :span="12">
                  <el-form-item label="Hình thức giao:" class="mb-0">
                    <span>{{checkEmpty(getTargetService)}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Tiền thu hộ COD:" label-width="160px" class="mb-0">
                    <span>{{formatMoneyNotUnit(CODfee) || '-'}}</span>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                  <el-form-item label="Shipper:" class="mb-0">
                    <div class="box-shipper-right">
                      <div class="d-flex justify-content-between box-search-shipper-right" style="height:40px">
                        <input v-model="dataItem.partyOther.displayName" @input="getListShippersDebounce" class="input-search-shipper-right">
                        <span class="text-bold">
                          <el-button class="border-0" style="background-color: #fff">
                            <b class="fz-18 text-black-50"><i class="fa-solid fa-angle-down"></i></b>
                          </el-button>
                        </span>
                      </div>
                      <div class="box-show-shipper-right">
                        <div class="wrap-box-show-shipper-right">
                          <div @click="modalAddShipperNew = true" class="add-choise-shipper">
                            <span class="btn-add-info"><b class="bx bx-plus text-primary fz-18"></b></span>
                            <span class="text-primary font-weight-bold fz-14">
                              Thêm mới shipper
                            </span>
                          </div>
                          <div v-if="listShipper.length > 0">
                            <div class="item-customer-choise" v-for="item in listShipper" :key="item.id">
                              <div @click="clickOneShipper(item)" class="itemShipper">
                                <div>{{ item.name }}</div>
                                <div>{{ item.phone }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                  <el-form-item label="Phí trả ĐTGH:" class="mb-0">
                    <el-input @input="($event) => inputMoney($event,'partyOtherFee')" v-model="partyOtherFee"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Phí báo khách:" label-width="160px" class="mb-0">
                    <div class="relative"><input :disabled="true" v-model="shippingFee" style="height: 40px;" class="input-dilivery">
                      <el-tooltip class="item" effect="dark" content="Không sửa được do khách đã thanh toán số tiền này trong đơn hàng." placement="bottom-end">
                        <img class="icon_more_info" style="position: absolute;top: 12px;right: 15px;" src="@assets/order-icon/more-info.svg" alt="more-info" />
                      </el-tooltip>
                    </div>
                  </el-form-item>
                </el-col>
            </el-row>
        </el-form>
      </div>
    </div>

    <el-dialog title="Thêm mới shipper" v-if="modalAddShipperNew" :visible.sync="modalAddShipperNew" id="modalAddShipperNew" width="440px"
			@close="modalAddShipperNewHide">
			<el-form label-position="top" :model="ruleFormShipper" :rules="rules" ref="ruleFormShipper" label-width="120px"
				class="ruleFormShipper">
				<el-form-item class="new-shipper-info" label="Họ và tên" prop="name">
					<el-input v-model="ruleFormShipper.name"></el-input>
				</el-form-item>
				<el-form-item class="new-shipper-info" label="Số điện thoại" prop="phone">
					<el-input v-model="ruleFormShipper.phone"></el-input>
				</el-form-item>
				<div style="float: right;">
					<el-button class="btn-default" @click="modalAddShipperNewHide">Thoát</el-button>
					<el-button type="primary" @click="submitFormShipper('ruleFormShipper')">Hoàn tất</el-button>
				</div>
			</el-form>
		</el-dialog>

  </div>
</template>

<script>
import Head from "./components/head.vue"
import { OrdersService } from "@/services/nextshop/orders.service"
import { OtherService } from "@/services/other.service";
import { ShipperServices } from '@/services/nextshop/shipper.service'
import { formatHHmmDDMMYYYY } from "../../utils/format";
import _ from "lodash"

export default {
  components: {
    Head,
  },
  data() {
    var checkDup = (rule, value, callback) => {
			setTimeout(() => {
				const listPhone = this.listShipper.map(e => e.phoneNo)
				if (listPhone.includes(value)) {
					callback(new Error('Số điện thoại bị trùng. Xin hãy nhập lại'));
				} else {
					callback();
				}
			}, 1000);
		};
    return {
      gatewayTransactionId: '',
      loading : false,
      id: this.$route.params.id,
      dataItem : {},
      listShipper: [],
      listCity: [],
      listDistrict: [],
      listWard: [],
      listLocations: [],
      dataCustomer: {
        city: null,
        district: null,
        ward: null,
      },
      ward: null,
      deliveryMethodNote: '',
      infoNote: '',
      CODfee: '',
      shippingFee: 0,
      partyOtherFee: 0,
      modalAddShipperNew: false,
			rules: {
				name: [
					{ required: true, message: 'Họ và tên không được để trống', trigger: 'blur' },
					{ min: 1, max: 255, message: 'Họ và tên không quá 255 ký tự', trigger: 'blur' }
				],
				phone: [
					{ required: true, message: 'Số điện thoại không được để trống', trigger: 'blur' },
					{ pattern: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/, message: 'Số điện thoại không hợp lệ', trigger: 'blur' },
					{ min: 1, max: 15, message: 'Số điện thoại không quá 15 kí tự', trigger: 'blur' },
					{ validator: checkDup, trigger: 'blur' }
				]
			},
      ruleFormShipper: {
				name: '',
				phone: ''
			},
    }
  },

  async created() {
    await this.getDetailDLO();
    await this.getListShippers('');
    await this.getListCity();
    await this.getListDistrict({ id: this.dataCustomer.city.id });
    await this.getListWard({ id: this.dataCustomer.district.id });
  },

  methods: {
    async getDetailDLO() {
      this.loading = true
      try {
        const response = await OrdersService.getDetailOrderDelivery(this.id)
        if (response.success) {
          this.loading = false
          this.dataItem = response.data.data;
          this.infoNote = response.data.data.note;
          await this.getDetailSO(this.dataItem.furtherInstructions[0].params.soOrderId)
          let locationCode = this.dataItem.furtherInstructions[0].params;
          this.dataCustomer.city = locationCode.shippingCity
          this.dataCustomer.district = locationCode.shippingDistrict
          this.dataCustomer.ward = locationCode.shippingVillage
          this.partyOtherFee = this.formatMoneyNotUnit(this.dataItem.lineItemFinalizing.finalAmount / 1000)
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    },

    async getDetailSO(id) {
      try {
        const response = await OrdersService.getOrderById(id);
        if (response.success) {
          let checkShippingFee = response.data.lineItemFinalizing.addedFee.find(e => e.key == 'SHIPPING_FEE')
          if(checkShippingFee) {
            this.shippingFee = this.formatMoneyNotUnit(checkShippingFee.amount / 1000)
          } else {
            return '-'
          }

          let checkCOD = response.data.outcomes.find(e => e.key == 'COD_NEXT_SHOP')
          if(checkCOD) {
            this.CODfee = checkCOD.params.amount / 1000
          } else {
            return '-'
          }
          
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateDLO() {
      this.loading = true
      const param = {
        note: this.infoNote,
        orderId: this.id,
        shipperInfo: {
          id: this.dataItem.partyOther.resId || '',
          name: this.dataItem.partyOther.displayName || '',
          phoneNo: this.dataItem.partyOther.phoneNo || ''
        },
        shippingAddress: {
          address: this.dataItem.furtherInstructions[0].params.shippingAddress || '',
          city: this.dataCustomer.city ? this.dataCustomer.city.id : '',
          district: this.dataCustomer.district ? this.dataCustomer.district.id : '',
          phoneNo: this.dataItem.partyB.phoneNo || '',
          receiverId: this.dataItem.furtherInstructions[0].params.receiverId ? this.dataItem.furtherInstructions[0].params.receiverId : '',
          receiverName: this.dataItem.partyB.displayName || '',
          village: this.ward ? this.ward.id : ''
        },
        shippingFeeForCustomer: this.checkNumReplaceComma(this.shippingFee) * 1000 || 0,
        shippingFeeForPartner:  this.checkNumReplaceComma(this.partyOtherFee) * 1000 || 0,
        viewModeType: 'NOT_SHOW'
      }
      try {
        const res = await  OrdersService.updateInforDLO(param);
        if (res.success) {
          this.loading = false
          this.$router.push({ path: `/orders-delivery/delivery-order-detail/${this.id}`})
        } 
      } catch (error) {
        this.loading = false
        console.log(error);
      }
    },

    async getListCity() {
      const response = await OtherService.getlistCity();
      this.listCity = response.data.map((e) => {
        return {
          id: e.code,
          text: e.name,
        };
      });
      const OBJ = await this.listCity.filter((e) => {
        if (e.id == this.dataCustomer.city) return e;
      });
      this.dataCustomer.city = OBJ[0];
    },

    async getListDistrict({ id }) {
      this.listDistrict = [];
      const response = await OtherService.getlistDistrict({
        cityCode: id,
        countryCode: "vn",
      });
      if (response.success) {
        this.listDistrict = response.data.map((e) => {
          return {
            id: e.code,
            text: e.name,
          };
        });
      }
      const OBJ = this.listDistrict.filter((e) => {
        if (e.id == this.dataCustomer.district) return e;
      });
      this.dataCustomer.district = OBJ[0];
    },

    async getListWard({ id }) {
      this.listWard = [];
      const response = await OtherService.getlistWard({
        cityCode: this.dataCustomer.city.id,
        countryCode: "vn",
        districtCode: id,
      });
      if (response.success) {
        this.listWard = response.data.map((e) => {
          return {
            id: e.code,
            text: e.name,
          };
        });
      }
      const OBJ = this.listWard.filter((e) => {
        if (e.id == this.dataCustomer.ward) return e;
      });
      return (this.ward = OBJ[0]);
    },

    async getListShippers(param){
			const params = {
				"pageNum": 1,
				"pageSize": 30,
				"searchText": param,
				"sortBy": "id",
				"sortType": "ASC"
			}
			const response = await ShipperServices.getListShipper(params)
			if(response.success){
				this.listShipper = []
				response.data.data.map((e) => {
					const tmp ={
						...e,
						text: e.name + " - " + e.phone
					}
					this.listShipper.push(tmp)
				})
			}
		},

    getListShippersDebounce: _.debounce(
      function() {
        this.getListShippers(this.dataItem.partyOther.displayName)
      }, 300),

    clickOneShipper(item) {
      this.dataItem.partyOther.displayName = item.name
      this.dataItem.partyOther.phoneNo = item.phone
      this.dataItem.partyOther.resId = item.id
    },

    modalAddShipperNewHide(){
			this.ruleFormShipper = {name : '', phone: ''}
			this.modalAddShipperNew = false
		},
		async submitFormShipper() {
			this.$refs.ruleFormShipper.validate(async(valid) => {
				if (valid) {
					this.modalAddShipperNew = false
					await this.quickAddShipper()
				} else {
					return false;
				}
			});
		},

    async quickAddShipper(){
			try {
				const params = {
					address: null,
					avatarUrl: null,
					email:null,
					name: this.ruleFormShipper.name,
					phone: this.ruleFormShipper.phone,
					shipperType: "STORE_TYPE"
				}
				const data = await ShipperServices.createShipper(params)
				if (data.success) {
					this.dataItem.partyOther.displayName = data.data.name
          this.dataItem.partyOther.phoneNo = data.data.phone
          this.dataItem.partyOther.resId = data.data.id
				}else{
					alert('Lỗi thêm mới shipper')
				}
			} catch (error) {
				console.log(error);
			}
		},
    
    checkEmpty(val) {
      if (val == "" || val == null || val == undefined) {
        return " - "
      } else {
        return val
      }
    },

    inputMoney(val, key) {
      if (key == 'partyOtherFee') {
        this.partyOtherFee = val
        this.partyOtherFee = this.formatMoneyNotUnit(this.partyOtherFee)
      } else {
        this.shippingFee = val
        this.shippingFee = this.formatMoneyNotUnit(this.shippingFee)
      }
    },

    linkTo() {
      this.$router.push({ path: `/pos/pos-detail/${this.dataItem.furtherInstructions[0].params.soOrderId}`})
    },
  },

  computed: {

    getTargetService() {
      if (this.dataItem.targetService == 'DELIVERY_PRIVATE_SHIPPER') {
        return 'Tự gọi shipper'
      } else if (this.dataItem.targetService == 'DELIVERY_PARTNER') {
        return 'Đẩy đơn qua hãng'
      }
    },

    checkoutAt() {
      return formatHHmmDDMMYYYY(this.dataItem.furtherInstructions[0].params.checkoutAt) || '-'
    }
  }
}

</script>
<style scoped lang="scss">
.boxContent .__card {
  max-width: 960px;
}

.first-box .el-row {
  margin-bottom: 10px;
}

.__card_title {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 0;
}
</style>
<style lang="scss">
.boxContent {
  margin: 12px 0;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 64%;
}
.el-row {
  margin-bottom: 18px;
}

.first-child {
  margin-bottom: 10px;
}

.multiselect__single {
font-size: 14px !important;
line-height: 23px;
color: #23313E;
}
.item-customer-choise {
	border-bottom: 1px solid #ddd;
	padding: 8px 10px;
	cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: left;

}
.item-customer-choise:hover {
  background: #fafafa;
}
.box-shipper-right{
	position: relative;
}
.box-shipper-right:hover .box-show-shipper-right{
	display: block;
  position: absolute;
  bottom: 42px;
}
.box-search-shipper-right{
  border: 1px solid #ddd;
  border-radius: 3px;
  position: relative;
  top: 1px;
}
.input-search-shipper-right{
	width: 85%;
	cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #495057;
  padding:0 15px;
}
.add-choise-customers,
.add-choise-shipper{
	border-bottom: 1px solid #ddd;
	padding: 8px 10px;
	cursor: pointer;
}
.box-show-shipper-right {
  position: absolute;
  background: #fff;
  display: inline-block;
  width: 100%;
  z-index: 2;
  display: none;
}
.wrap-box-show-shipper-right {
	max-height: 200px;
	overflow-y: scroll;
	border: 1px solid #ddd;
	border-radius: 2px;
}
.itemShipper{
	position: relative;
}
.itemShipperUpdate {
  position: absolute;
  right: 0;
  top: 8px;
  text-transform: uppercase;
  color: #3E69F6;
}

.new-shipper-info .el-form-item__content {
  width: 100%;
}
</style>